class Panel {
  constructor({ el }) {
    this.el = el;
    this.panel = el.querySelector("[data-panel]");
    this.modal = document.querySelector("#mini-cart-gift-modal");
    this.closeButton = el.querySelector("[data-panel-close]");

    this.close = this.close.bind(this);
    this.checkExceptions = this.checkExceptions.bind(this);
    this.escToClose = this.escToClose.bind(this);
  }

  bindEvents() {
    this.el.addEventListener("click", this.checkExceptions);
    this.closeButton.addEventListener("click", this.close);
    window.addEventListener("keydown", this.escToClose);
  }

  unbindEvents() {
    this.closeButton.removeEventListener("click", this.close);
    window.removeEventListener("keydown", this.escToClose);
    this.el.addEventListener("click", this.checkExceptions);
  }

  checkExceptions(e) {
    const exceptions = [
      ".panel__item",
      ".increase-button",
      ".decrease-button",
      ".mini-cart__item-remove",
    ];
    const clickedElement = e.target;
    const isException = exceptions.some((exception) => clickedElement.closest(exception));
    if (!isException) {
      this.close();
    }
  }

  open() {
    this.el.classList.add("panel--open");
    document.body.classList.add("panel-is-open");

    setTimeout(() => {
      this.closeButton.focus();

      window.addEventListener("keydown", (e) => {
        const checkoutButton = document.querySelector(".mini-cart__total .button");
        const agreeToTermsButton = document.querySelector(".mini-cart__total .terms-chevron");

        if (e.key === "Tab" && e.target === agreeToTermsButton && checkoutButton.disabled) {
          e.preventDefault();
          setTimeout(() => this.closeButton.focus(), 500);
        }

        if (e.key === "Tab" && e.target === checkoutButton) {
          e.preventDefault();
          setTimeout(() => this.closeButton.focus(), 500);
        }
      });
    }, 1000);
    this.bindEvents();
  }

  close() {
    const closePanel = new CustomEvent("onPanelClose");
    this.el.classList.remove("panel--open");
    document.body.classList.remove("panel-is-open");
    this.unbindEvents();
    document.querySelector("#cart-icon-bubble")?.focus();
    this.el.dispatchEvent(closePanel);
  }

  escToClose(e) {
    if (e.key === "Escape") {
      this.close();
    }
  }
}

window.Panel = Panel;
